<script setup lang="ts">
import Message from 'primevue/message';
</script>

<template>
  <Message severity="warn" :closable="false">
    Esta política foi excluída. Os relatórios gerados com ela continuam disponíveis, mas novos relatórios não podem ser solicitados com essa política.
  </Message>
</template>
